import randomElement from "../randomElement";
import randomSubset from "../randomSubset";
import shuffle from "../shuffle";
import defaultParams from "../defaultParams";

function ManyAnsQuestion(minigameData, state){
    var n_min, n_wrong, n_wrong_min, minigametype, arr_wrong, arr_right, n_right;
    let variants = [];
    let comms = [];
    let data = randomElement(minigameData.data.questions);
    let ansScore = [];
    let qType = "standart";
	switch (Number(state.objects.difficulty)) {
		case 0:
            n_min = minigameData.variantCount ? minigameData.variantCount[0] - 1 : defaultParams.variantCountManyAnsQuestion[0][0];
            n_wrong_min = minigameData.variantCount ? minigameData.variantCount[0] - 1 : defaultParams.variantCountManyAnsQuestion[0][1];
            arr_wrong = data.wrong_ans;
            minigametype = 'ManyAnsQuestion';
            break;
		case 1:
            n_min = minigameData.variantCount ? minigameData.variantCount[1] - 1 : defaultParams.variantCountManyAnsQuestion[1][0];
            n_wrong_min = minigameData.variantCount ? minigameData.variantCount[0] - 1 : defaultParams.variantCountManyAnsQuestion[1][1];
            arr_wrong = (data.wrong_ans1) ? data.wrong_ans1 : data.wrong_ans; 
            minigametype = 'ManyAnsQuestion';
			break;
		default:
			throw new Error(`Difficulty '${state.objects.difficulty}' is not implemented`);
    }
    
    arr_right = data.correct_ans;
    n_right = arr_right.length;
    n_wrong = Math.max(n_min - n_right, n_wrong_min);
    arr_wrong = randomSubset(arr_wrong, n_wrong);
    variants = shuffle(arr_wrong.concat(arr_right));
    let border = variants.length;

    let specialVar = ["Ни один", "Ни одна", "Все перечисленные"];
    if(typeof(data.correct_ans[0]) === "object") {
        for(let i = 0; i < border; i++){
            if(specialVar.some(elem => variants[i].ans.includes(elem))){
                let temp = variants[i];
                variants.splice(i, 1);
                variants.push(temp);
                border = border - 1;
                qType = "special";
            }
        }
        arr_right = arr_right.map(elem => elem.ans);
        comms = variants.map(elem => elem.comm ? elem.comm : null);
        ansScore = variants.map(elem => elem.score); 
        variants = variants.map(elem => elem.ans);
        
    }
    if(variants.some(elem => elem.length > 50)){
        qType = "big";
    }
    let form = {
        question: data.qst,
        options: variants,
        comms: comms,
        scores: ansScore,
        correct: arr_right.map(elem => variants.indexOf(elem)),
        type: minigametype,
        qType: qType
    }
    return form;
}

export default ManyAnsQuestion;

function range(n, start = 0) {
    const res = [];
    for (let i = start; i <= n; i++) {
        res.push(i);
    }
    return res;
}